import { SyntheticEvent, useCallback, useState } from 'react'

export const useFocus = (
  timer: number = 0,
  onStateChange?: (focus: boolean) => void,
  focusTimer?: number
) => {
  const [focused, setFocused] = useState(false)
  const [state] = useState<{
    focused: boolean
    timeout: any
    focusTimeout: any
  }>({
    focused: false,
    timeout: 0,
    focusTimeout: 0,
  })

  const onFocus = useCallback(() => {
    state.focused = true
    state.focusTimeout = setTimeout(() => {
      setFocused(true)
      onStateChange && onStateChange(true)
    }, focusTimer)

    clearTimeout(state.timeout)
  }, [onStateChange, state, focusTimer])

  const onBlur = useCallback(
    (event?: SyntheticEvent<Element, FocusEvent>) => {
      if (!event || !(event.target as Element).contains(document.activeElement)) {
        state.focused = false
        state.timeout = setTimeout(() => {
          setFocused(false)
          onStateChange && onStateChange(false)
        }, timer)
        clearTimeout(state.focusTimeout)
      }
    },
    [onStateChange, state, timer]
  )

  return { onFocus, onBlur, focused }
}
